import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

const RequireAuth = ({ children }) => {
    const { isLoggedIn, authLoading } = useAuth();
    const location = useLocation();

    if (!isLoggedIn && !authLoading) {
      return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
};

export default RequireAuth;